// default parallax is 0.12
const imageDefinitions = [
	{
		page: '1',
		src: './parallax-images/1-stairs.jpg',
		alt: 'Stairs',
		left: '80%',
		top: '10%',
		width: '40%',
    modal: true,
		mobile: {
			left: '15%',
			bottom: '-0%',
			width: '80%',
		},
	},
  {
		page: '1',
		src: './parallax-images/2_ball.png',
		alt: 'La Bola Negra Sketch',
		left: '77%',
		top: '7%',
		width: '10%',
    modal: false,
    parallax: 0.19,
		mobile: {
			left: '5%',
			bottom: '17%',
			width: '25%',
      parallax: 0.12,
		},
    
	},
  {
		page: '2',
		src: './parallax-images/2-group.jpg',
		alt: 'Group Photo in Black and White',
		right: '-20%',
		top: '5%',
		width: '70%',
    modal: true,
		mobile: {
			left: '5%',
			bottom: '25%',
			width: '75%',
		},
	},
  {
		page: '2',
		src: './parallax-images/2-group-color.jpg',
		alt: 'Group Photo in Color',
		right: '-10%',
		bottom: '5%',
		width: '50%',
    modal: true,
    parallax: 0.17,
		mobile: {
			left: '5%',
			bottom: '-25%',
			width: '60%',
      parallax: 0.12,
		},
	},
  {
		page: '3',
		src: './parallax-images/3-old-photo.jpg',
		alt: 'Old Photo',
		left: '25%',
		bottom: '5%',
		width: '30%',
    modal: true,
    parallax: 0.1,
		mobile: {
			left: '5%',
			top: '40%',
			width: '90%',
      parallax: 0.12,
		},
	},
  {
		page: '3',
		src: './parallax-images/3-sketch.png',
		alt: 'Sketch',
		right: '25%',
		top: '15%',
		width: '10%',
    modal: false,
    parallax: 0.19,
		mobile: {
			right: '5%',
			top: '5%',
			width: '25%',
      parallax: 0.12,
		},
	},
  {
		page: '5',
		src: './parallax-images/5-hug.jpg',
		alt: 'Hug',
		left: '-10%',
		top: '5%',
		width: '35%',
    parallax: 0,
		mobile: {
			right: '5%',
			top: '-5%',
			width: '60%',
      parallax: 0.12,
		},
	},
  {
		page: '7',
		src: './parallax-images/7-painting-set.jpg',
		alt: 'Painting Set',
		right: '-15%',
		top: '5%',
		width: '65%',
    parallax: 0.15,
		mobile: {
			right: '5%',
			bottom: '-15%',
			width: '80%',
      parallax: 0.12,
		},
	},
  {
		page: '11',
		src: './parallax-images/10-light.jpg',
		alt: 'Light Setup',
		left: '10%',
		bottom: '5%',
		width: '40%',
    parallax: 0.08,
		mobile: {
			left: '5%',
			top: '28%',
			width: '70%',
      parallax: 0.12,
		},
	},
  {
		page: '11',
		src: './parallax-images/10-dance.jpg',
		alt: 'Light Setup',
		right: '5%',
		top: '5%',
		width: '40%',
    parallax: 0,
		mobile: {
			right: '5%',
			top: '48%',
			width: '70%',
      parallax: 0.12,
		},
	},
  {
		page: '12',
		src: './parallax-images/12-35mm.png',
		alt: 'filmed and projected in 35mm',
		right: '7%',
		bottom: '20%',
		height: '18%',
    parallax: '0',
    modal: false,
		mobile: {
			left: '35%',
			bottom: '15%',
			width: '30%',
      parallax: 0,
		},
	},
  {
		page: '13',
		src: './parallax-images/13-pointing.jpg',
		alt: 'Pointing',
		right: '-10%',
		bottom: '10%',
		width: '30%',
		mobile: {
			right: '5%',
			bottom: '15%',
			width: '60%',
      parallax: 0.12,
		},
	},
  {
		page: '15',
		src: './parallax-images/15-sailors.jpg',
		alt: 'Sailors',
		right: '-10%',
		top: '5%',
		width: '40%',
		mobile: {
			left: '5%',
			bottom: '-15%',
			width: '80%',
      parallax: 0.12,
		},
	},
  {
		page: '15',
		src: './parallax-images/15-peacock.png',
		alt: 'Peacock',
		right: '-10%',
		bottom: '10%',
		width: '22%',
    modal: false,
		mobile: {
			right: '15%',
			bottom: '-40%',
			width: '40%',
      parallax: 0.17,
		},
	},
  {
		page: '16',
		src: './parallax-images/16-costume-designer.jpg',
		alt: 'Costume Designer',
		right: '-10%',
		top: '12%',
		width: '30%',
		mobile: {
			right: '5%',
			bottom: '20%',
			width: '60%',
      parallax: 0.12,
		},
	},
  {
		page: '16',
		src: './parallax-images/16-costumes.jpg',
		alt: 'Costumes',
		right: '-10%',
		bottom: '10%',
		width: '40%',
		mobile: {
			right: '5%',
			bottom: '-1%',
			width: '80%',
      parallax: 0.12,
		},
	},
  {
		page: '17',
		src: './parallax-images/17-room.jpg',
		alt: 'Room',
		right: '10%',
		bottom: '10%',
		width: '30%',
		mobile: {
			left: '5%',
			bottom: '-30%',
			width: '70%',
      parallax: 0.12,
		},
	},
  {
		page: '19',
		src: './parallax-images/19-paint-roller.png',
		alt: 'Paint Roller',
		left: '45%',
		bottom: '20%',
		width: '15%',
    modal: false,
		mobile: {
			right: '5%',
			top: '10%',
			width: '30%',
      parallax: 0.12,
		},
	},
  {
		page: '19',
		src: './parallax-images/19-stone-house.jpg',
		alt: 'Stone House',
		right: '-15%',
		top: '10%',
		width: '45%',
		mobile: {
			left: '5%',
			bottom: '40%',
			width: '80%',
      parallax: 0.12,
		},
	},
  {
		page: '24',
		src: './parallax-images/24-trumpet.png',
		alt: 'Trumpet',
		right: '15%',
		bottom: '10%',
		width: '25%',
		mobile: {
      page: '25',
      standalone: true,
      standaloneHeight: '760px',
			left: '5%',
			top: '15%',
			width: '50%',
      parallax: 0.12,
		},
	},
  {
		page: '24',
		src: './parallax-images/24-piano.jpg',
		alt: 'Piano',
		right: '-10%',
		top: '10%',
		width: '40%',
		mobile: {
      page: '25',
			right: '5%',
			bottom: '-5%',
			width: '70%',
      parallax: 0.12,
		},
	},
  {
		page: '26',
		src: './parallax-images/26-snow-makeup.jpg',
		alt: 'Snow Makeup',
		right: '-10%',
		bottom: '10%',
		width: '35%',
		mobile: {
			left: '5%',
			bottom: '-15%',
			width: '80%',
      parallax: 0.12,
		},
	},
  {
		page: '28',
		src: './parallax-images/28-portraits.jpg',
		alt: 'Portraits',
		left: '-5%',
		top: '10%',
		width: '50%',
		mobile: {
			right: '5%',
			top: '-3%',
			width: '90%',
      parallax: 0.12,
		},
	},
  {
		page: '28',
		src: './parallax-images/28-applying-makeup.jpg',
		alt: 'Applying Makeup',
		left: '-5%',
		top: '40%',
		width: '30%',
		mobile: {
			right: '5%',
			top: '12%',
			width: '50%',
      parallax: 0.12,
		},
	},
  {
		page: '28',
		src: './parallax-images/28-wig.png',
		alt: 'Wig',
		left: '60%',
		top: '20%',
		width: '15%',
    parallax: 0.17,
    modal: false,
		mobile: {
			left: '10%',
			top: '25%',
			width: '30%',
      parallax: 0.17,
		},
	},
  {
		page: '29',
		src: './parallax-images/29-flag.jpg',
		alt: 'Flag',
		left: '-10%',
		bottom: '15%',
		width: '60%',
		mobile: {
			left: '5%',
			top: '-20%',
			width: '55%',
      parallax: 0.12,
		},
	},
  {
		page: '30',
		src: './parallax-images/30-trumpet.jpg',
		alt: 'Trumpet',
		right: '-30%',
		bottom: '15%',
		width: '60%',
    parallax: 0.17,
		mobile: {
			right: '5%',
			bottom: '5%',
			width: '60%',
      parallax: 0.12,
		},
	},
  {
		page: '31',
		src: './parallax-images/31-looking-down.jpg',
		alt: 'Looking Down',
		right: '-30%',
		top: '15%',
		width: '60%',
		mobile: {
			left: '5%',
			bottom: '-15%',
			width: '70%',
      parallax: 0.12,
		},
	},
  {
		page: '33',
		src: './parallax-images/33-sheet-music.jpg',
		alt: 'Sheet Music',
		left: '-15%',
		top: '15%',
		width: '50%',
		mobile: {
			right: '5%',
			top: '-10%',
			width: '70%',
      parallax: 0.12,
		},
	},
  {
		page: '36',
		src: './parallax-images/36-typewriter.jpg',
		alt: 'Typewriter',
		left: '-5%',
		top: '10%',
		width: '55%',
		mobile: {
			left: '10%',
			top: '-10%',
			width: '80%',
      parallax: 0.12,
		},
	},
  {
		page: '36',
		src: './parallax-images/36-arrow.png',
		alt: 'Arrow',
		right: '-5%',
		top: '10%',
		width: '25%',
    modal: false,
		mobile: {
			left: '35%',
			bottom: '-10%',
			width: '30%',
      parallax: 0.12,
		},
	},
  {
		page: '37',
		src: './parallax-images/38-pages.png',
		alt: 'Handwritten Pages',
		loading: 'eager',
		right: '-35%',
		top: '15%',
		width: '40%',
		mobile: {
			left: '5%',
			bottom: '7%',
			width: '90%',
      parallax: 0.12,
		},
	},

];

export default imageDefinitions;